module.exports = __webpack_public_path__ + "static/property7-4e733dc7cd346107a72e506387fc7b0f.png";